// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"773":"428027cc","1994":"f8d25863","4753":"f8d25863","7238":"12c6265f"}[chunkId] + ".chunk.css";
};